import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export default function PaymentSuccessScreen() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get order ID from URL if available
  const orderId = searchParams.get("orderId");

  useEffect(() => {
    // Auto-redirect to orders page after 5 seconds
    const timer = setTimeout(() => {
      void navigate("/fulfillment/orders");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          <CardTitle className="text-2xl">Payment Successful!</CardTitle>
          <CardDescription>
            Your payment has been processed successfully.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center text-sm text-muted-foreground">
            <p>Thank you for your payment.</p>
            {orderId && (
              <p className="mt-2">
                Order ID:{" "}
                <span className="font-mono font-semibold">{orderId}</span>
              </p>
            )}
            <p className="mt-4">Redirecting to orders page in 5 seconds...</p>
          </div>
          <div className="flex gap-2">
            <Button
              onClick={() => navigate("/fulfillment/orders")}
              className="flex-1"
            >
              View Orders
            </Button>
            <Button
              onClick={() => navigate("/dispatch")}
              variant="outline"
              className="flex-1"
            >
              Go to Dispatch
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
